import React from 'react'
import NavBar from '../Components/NavBar/NavBar'
import Product from '../Components/Product/Product'
import Footer from '../Components/Footer/Footer'

const ProductComp = () => {
  return (
    <div>
      <NavBar/>
      <Product/>
      <Footer/>
    </div>
  )
}

export default ProductComp

